/**
 * Google Tag Manager Utilities
 */

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (command: string, ...args: any[]) => void;
  }
}

/**
 * Push an event to the GTM dataLayer
 * Only does something in production when GTM is loaded
 */
export function pushGTMEvent(eventName: string, eventData?: Record<string, any>) {
  if (typeof window === "undefined") return;

  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    });
  }
}

/**
 * Track waitlist submission event
 * - Client-side: pushes to GTM dataLayer
 * - Server-side: sends to Reddit CAPI (if configured)
 */
export async function trackWaitlistSubmit(email?: string) {
  // Client-side GTM event
  pushGTMEvent("waitlist_submit", {
    email,
    timestamp: new Date().toISOString(),
  });

  // Server-side CAPI event (fires asynchronously, doesn't block)
  if (email && typeof window !== "undefined") {
    // Get client info for CAPI
    const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : undefined;

    // Fire and forget - don't await to avoid blocking UI
    fetch("/api/ads/reddit-capi/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventType: "lead",
        email,
        userAgent,
      }),
    }).catch(() => {
      // Silently fail - CAPI is best-effort
    });
  }
}
